import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { SvgIcon } from '../../../../../../../common/react/components/SvgIcon';

export const StatsLeadersFilterButton = ( { onFilterVisibilityChange } ) => {
    // @ts-ignore
    const { translations } = PULSE.I18N;

    const [
        areFilterOptionsVisible,
        setAreFilterOptionsVisible
    ] = useState( false );

    useEffect( () => {
        onFilterVisibilityChange( areFilterOptionsVisible );
    }, [ areFilterOptionsVisible ] );

    return (
        <button
            className={classNames( 'stats-leaders-filter-button', {
                'stats-leaders-filter-button--active': areFilterOptionsVisible
            } )}
            onClick={ () => {
                setAreFilterOptionsVisible( prev => !prev );
            } }
        >
            <SvgIcon
                icon="filter-circle"
                className="stats-leaders-filter-button__icon"
            />
            <SvgIcon
                icon="filter-circle-fill"
                className="stats-leaders-filter-button__icon-active"
            />
            { translations[ 'label.statsLeaders.filters.toggleButtonText' ] }
        </button>
    );
};

StatsLeadersFilterButton.propTypes = {
    onFilterVisibilityChange: PropTypes.func.isRequired
};
